import type { SVGProps } from 'react';

const SvgCastOffBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M7 15H12M3 5.875C3 5.39175 3.40294 5 3.9 5H15.5C15.9971 5 16.4 5.39175 16.4 5.875V9.64583C16.4 9.64583 21 6 21 8.1875C21 10.375 21 14.5 21 16.25C21 18 16.4 14.7917 16.4 14.7917V18.125C16.4 18.6083 15.9971 19 15.5 19H3.9C3.40294 19 3 18.6083 3 18.125V5.875Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgCastOffBd;
